export default __webpack_public_path__ + "static/media/featured-item-1.429fbde0.png";